var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_661_14815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0914 19.7222H34.0451C34.5173 19.7222 34.7534 19.7222 34.8914 19.8215C35.0119 19.9081 35.0903 20.0414 35.1075 20.1888C35.1272 20.3577 35.0126 20.564 34.7833 20.9768L33.3624 23.5343C33.2793 23.684 33.2377 23.7589 33.2214 23.8381C33.207 23.9083 33.207 23.9806 33.2214 24.0508C33.2377 24.13 33.2793 24.2049 33.3624 24.3545L34.7833 26.9121C35.0126 27.3248 35.1272 27.5312 35.1075 27.7001C35.0903 27.8475 35.0119 27.9808 34.8914 28.0674C34.7534 28.1667 34.5173 28.1667 34.0451 28.1667H26.6136C26.0224 28.1667 25.7269 28.1667 25.5011 28.0516C25.3024 27.9504 25.141 27.7889 25.0398 27.5903C24.9247 27.3645 24.9247 27.0689 24.9247 26.4778V23.9444M21.2303 34.5L17.0081 17.6111M18.5914 23.9444H26.4025C26.9937 23.9444 27.2892 23.9444 27.515 23.8294C27.7137 23.7282 27.8751 23.5667 27.9763 23.3681C28.0914 23.1423 28.0914 22.8467 28.0914 22.2556V17.1889C28.0914 16.5977 28.0914 16.3021 27.9763 16.0763C27.8751 15.8777 27.7137 15.7162 27.515 15.615C27.2892 15.5 26.9937 15.5 26.4025 15.5H18.6433C17.906 15.5 17.5374 15.5 17.2852 15.6528C17.0642 15.7867 16.9 15.997 16.8237 16.2439C16.7366 16.5256 16.8261 16.8832 17.0049 17.5985L18.5914 23.9444Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_661_14815",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_661_14815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_661_14815",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIcon);
export default __webpack_public_path__ + "static/media/register-icon.07ac331037881b6f8ca3fe4cbdcc9b4f.svg";
export { ForwardRef as ReactComponent };